import React from "react"
import { Box, Button, ThemeProvider } from '@mui/material'
import Header from '../../components/Header'

import { useState, useEffect } from 'react'
import { useTheme } from '@mui/material'
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'

import * as Constants from '../../constants'

const DelUser = () => {
  let theme = useTheme()

  const [error, setError] = useState({ error: false, message: '' })
  const [success, setSuccess] = useState({ success: false, message: '' })
  const [user, setUser] = useState('')

  const id = useParams().id
  const navigate = useNavigate()

  useEffect(() => {
    // Fetch username
    fetch(Constants.HOST + '/users', {
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
      body: JSON.stringify({
        token: JSON.parse(localStorage.getItem('user_data')).token,
      }),
    })
      .then((response) => {
        if (response.status !== 400 && response.status !== 200) {
          setError({
            error: true,
            message: 'Erro de comunicação com o servidor',
          })
          setSuccess({ success: false, message: '' })
        } else {
          response.json().then((data) => {
            if (data.success !== true || data.data.users === undefined) {
              setError({ error: true, message: data.message})
              setSuccess({ success: false, message: '' })
            } else {
              data = data.data
              data.users.find((user) => {
                if (user.id == id) {
                  setUser(user.username)
                }
              })
            }
          })
        }
      })
      .catch((error) => {
        setError({ error: true, message: 'Erro de comunicação com o servidor' })
        setSuccess({ success: false, message: '' })
      })
  }, [])

  const handleSubmit = () => {
    fetch(Constants.HOST + '/deleteUser', {
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
      body: JSON.stringify({
        token: JSON.parse(localStorage.getItem('user_data')).token,
        user_id: id,
      }),
    })
      .then((response) => {
        if (response.status !== 400 && response.status !== 200) {
          setError({
            error: true,
            message: 'Erro de comunicação com o servidor',
          })
          setSuccess({ success: false, message: '' })
        } else {
          response.json().then((data) => {
            if (data.success === false && data.message !== undefined) {
              setError({ error: true, message: data.message })
              setSuccess({ success: false, message: '' })
            } else {
              setError({ error: false, message: '' })
              setSuccess({ success: true, message: data.message })
              navigate('/team')
            }
          })
        }
      })
      .catch((error) => {
        setError({ error: true, message: 'Erro de comunicação com o servidor' })
        setSuccess({ success: false, message: '' })
      })
  }

  return (
    <Box m="20px">
      <Header
        title="Excluir usuário"
        subtitle={`Você está prestes a excluir o usuário ${user}.`}
      />
      {error.error && (
        <div style={{ color: 'red', margin: '10px 0' }}>{error.message}</div>
      )}
      {success.success && (
        <div style={{ color: 'green', margin: '10px 0' }}>
          {success.message}
        </div>
      )}

      <ThemeProvider theme={theme}>
        <Box sx={{ flexGrow: 1, display: 'flex' }}>
          <Button
            variant="outlined, contained"
            sx={{ marginLeft: '10px', bgcolor: 'green' }}
            onClick={() => navigate('/team')}
          >
            Cancelar
          </Button>
          <Button
            variant="outlined, contained"
            sx={{ marginLeft: '10px', bgcolor: 'red' }}
            onClick={handleSubmit}
          >
            Excluir
          </Button>
        </Box>
      </ThemeProvider>
    </Box>
  )
}

export default DelUser
